import { CFormSelect } from "@coreui/react";

const DownloadReportModal = ({ isOpen, onClose }) => {
    if (!isOpen) return null;

    return (
        <div
            style={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "fixed",
                top: 0,
                left: 0,
                width: "100%",
                height: "100%",
                backgroundColor: "rgba(0, 0, 0, 0.5)",
                zIndex: 1000,
            }}>
            <div
                style={{
                    width: "90%",
                    maxWidth: "400px",
                    backgroundColor: "white",
                    padding: "20px",
                    borderRadius: "10px",
                    boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                    textAlign: "center",
                }}>
                <h2>Download Report</h2>
                <p className="my-3">Please choose a download format below.</p>
                <CFormSelect>
                    <option>PDF</option>
                    <option>CSV</option>
                    <option>Excel</option>
                </CFormSelect>
                <div className="d-flex gap-3 mt-3">
                    <button onClick={onClose}
                        style={{
                            padding: "10px",
                            backgroundColor: "#DC3545",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            width: "100%",
                            maxWidth: "300px",
                        }}>Close</button>
                    <button
                        style={{
                            padding: "10px",
                            backgroundColor: "#673AB7",
                            color: "white",
                            border: "none",
                            borderRadius: "5px",
                            cursor: "pointer",
                            fontSize: "16px",
                            width: "100%",
                            maxWidth: "300px",
                        }}>Download Report</button>
                </div>
            </div>
        </div>
    );
};

export default DownloadReportModal;